/* Load Modules */
import { memoize } from "lodash";

/* Load Components */
import { FormBox } from "../../../../../../../utils/forms/components/FormBoxes";

/* Load Constants */
import * as SETTINGS_CONSTS from "./SettingsConfiguratinSection.constants";
import buildFormGridFields from "../../../../../../../utils/forms/builders/build-form-grid-fields";
import buildSchemaCompliantDefinition from "../../../../../../../utils/forms/builders/build-schema-compliant-definition";
//import { checkIfConditionMeet } from "../../../../../../../utils/utils";

export const settingsConfigBox = ({
    country,
    schema,
    session_type,
    point_system,
    form_values,
    regions,
    regionPresets
}): FormBox[] => {
    const settingsFormDefinition = SETTINGS_CONSTS.SETTINGS_FORM_DEFINITION(
        country,
        session_type,
        point_system,
        form_values,
        schema,
        regions,
        regionPresets
    );

    let changedSchema = {
        ...schema
    };
    let communicationSchema = {
        type: "array",
        items: {
            type: "string"
        },
        uniqueItems: true
    };

    /*if (form_values && checkIfConditionMeet(form_values, changedSchema)) {
            changedSchema["then"]["required"].map(required => {
                if (!changedSchema.required.includes(required)) {
                    changedSchema.required.push(required);
                }
            });
        }*/

    /*
    // REMOVE COMMUNICATION PROTOCOLS
    changedSchema.properties[
        SETTINGS_CONSTS.SCHEMA_NAMES.COMMUNICATION_PROTOCOLS
    ] = communicationSchema;

    if (
        !changedSchema.required.includes(
            SETTINGS_CONSTS.SCHEMA_NAMES.COMMUNICATION_PROTOCOLS
        )
    ) {
        changedSchema.required.push(
            SETTINGS_CONSTS.SCHEMA_NAMES.COMMUNICATION_PROTOCOLS
        );
    }
     */

    if (
        session_type == "auto" &&
        !changedSchema.required.includes(
            SETTINGS_CONSTS.SCHEMA_NAMES.AUTO_SESSION_TIME
        )
    ) {
        changedSchema.required.push(
            SETTINGS_CONSTS.SCHEMA_NAMES.AUTO_SESSION_TIME
        );
    } else if (
        session_type !== "auto" &&
        changedSchema.required.includes(
            SETTINGS_CONSTS.SCHEMA_NAMES.AUTO_SESSION_TIME
        )
    ) {
        changedSchema.required.splice(
            changedSchema.required.indexOf(
                SETTINGS_CONSTS.SCHEMA_NAMES.AUTO_SESSION_TIME
            ),
            1
        );
    }

    if (
        point_system &&
        !changedSchema.required.includes(SETTINGS_CONSTS.SCHEMA_NAMES.REGION)
    ) {
        changedSchema.required.push(SETTINGS_CONSTS.SCHEMA_NAMES.REGION);
    } else if (
        !point_system &&
        changedSchema.required.includes(SETTINGS_CONSTS.SCHEMA_NAMES.REGION)
    ) {
        changedSchema.required.splice(
            changedSchema.required.indexOf(SETTINGS_CONSTS.SCHEMA_NAMES.REGION),
            1
        );
    }

    const formDefinition = buildSchemaCompliantDefinition(
        changedSchema,
        settingsFormDefinition
    );

    return [
        {
            fields: buildFormGridFields(changedSchema, formDefinition),
            columnClass: "col-12"
        }
    ];
};

export const bingoConfigBox: (schema, country, points_system, subsidiaryId) => FormBox[] = (schema, country, points_system, subsidiaryId) => {
    const formDefinition = buildSchemaCompliantDefinition(
        schema,
        SETTINGS_CONSTS.BINGO_FORM_DEFINITION(country, points_system, subsidiaryId)
    );

    return [
        {
            title: SETTINGS_CONSTS.CONFIGURATION_BINGO_TITLE,
            fields: buildFormGridFields(schema, formDefinition),
            columnClass: "col-12"
        }
    ];
};

export const spinsConfigBox: (schema) => FormBox[] = schema => {
    const formDefinition = buildSchemaCompliantDefinition(
        schema,
        SETTINGS_CONSTS.SPINS_FORM_DEFINITION
    );

    return [
        {
            title: SETTINGS_CONSTS.CONFIGURATION_SPINS_TITLE,
            fields: buildFormGridFields(schema, formDefinition),
            columnClass: "col-12"
        }
    ];
};

export const lottoConfigBox: (schema, country, points_system, subsidiaryId) => FormBox[] = (schema, country, points_system, subsidiaryId) => {
    const formDefinition = buildSchemaCompliantDefinition(
        schema,
        SETTINGS_CONSTS.LOTTO_FORM_DEFINITION(country, points_system, subsidiaryId)
    );

    return [
        {
            title: SETTINGS_CONSTS.CONFIGURATION_LOTTO_TITLE,
            fields: buildFormGridFields(schema, formDefinition),
            columnClass: "col-12"
        }
    ];
};

export const kenoConfigBox: (schema, country, points_system, subsidiaryId) => FormBox[] = (schema, country, points_system, subsidiaryId) => {
    const formDefinition = buildSchemaCompliantDefinition(
        schema,
        SETTINGS_CONSTS.KENO_FORM_DEFINITION(country, points_system, subsidiaryId)
    );

    return [
        {
            title: SETTINGS_CONSTS.CONFIGURATION_KENO_TITLE,
            fields: buildFormGridFields(schema, formDefinition),
            columnClass: "col-12"
        }
    ];
};

export const pointSystemConfigBox: (schema, regions, regionPresets, form_values) => FormBox[] = (schema, regions, regionPresets, form_values) => {
    const formDefinition = buildSchemaCompliantDefinition(
        schema,
        SETTINGS_CONSTS.POINT_SYSTEM_FORM_DEFINITION(regions, regionPresets, form_values)
    );

    return [
        {
            title: SETTINGS_CONSTS.CONFIGURATION_POINT_SYSTEM_TITLE,
            fields: buildFormGridFields(schema, formDefinition),
            columnClass: "col-12"
        }
    ];
};

export const panelsConfigBox: (schema) => FormBox[] = schema => {
    const formDefinition = buildSchemaCompliantDefinition(
        schema,
        SETTINGS_CONSTS.PANEL_FORM_DEFINITION
    );

    return [
        {
            title: SETTINGS_CONSTS.CONFIGURATION_PANELS_TITLE,
            fields: buildFormGridFields(schema, formDefinition),
            columnClass: "col-12"
        }
    ];
};